<template>
  <section class="p-6 max-w-5xl mx-auto">
    <div class="flex items-end justify-between mb-5 gap-4 flex-wrap">
      <div>
        <h1 class="font-heading font-bold text-xl">Team access</h1>
        <p class="text-[13px] text-gray-500 dark:text-dark-text-muted mt-1">
          Control who can view, draft, and publish SMS flow changes
        </p>
      </div>
      <button class="btn btn-primary btn-sm">
        <user-plus-icon class="w-3.5 h-3.5" /> Invite team member
      </button>
    </div>

    <!-- Role guide -->
    <div class="grid sm:grid-cols-3 gap-4 mb-6">
      <div
        v-for="r in roleGuide"
        :key="r.role"
        class="card card-body"
        :class="r.accent"
      >
        <div class="font-heading font-bold text-[13px]">{{ r.role }}</div>
        <div
          class="text-[13px] text-gray-500 dark:text-dark-text-muted mt-1 leading-relaxed"
        >
          {{ r.desc }}
        </div>
      </div>
    </div>

    <!-- Team table -->
    <div class="card overflow-hidden">
      <div class="card-header"><div class="card-title">Team members</div></div>
      <div class="overflow-x-auto">
        <table class="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Role (Callia)</th>
              <th>Portal access</th>
              <th>BU scope</th>
              <th>Last active</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="m in team" :key="m.email">
              <td>
                <div class="flex items-center gap-2">
                  <div
                    class="w-7 h-7 rounded-full text-[11px] font-semibold flex items-center justify-center"
                    :class="m.avatarClass"
                  >
                    {{ m.initials }}
                  </div>
                  <div>
                    <div class="font-medium">{{ m.name }}</div>
                    <div
                      class="text-[11px] text-gray-500 dark:text-dark-text-muted"
                    >
                      {{ m.email }}
                    </div>
                  </div>
                </div>
              </td>
              <td>{{ m.role }}</td>
              <td>
                <span class="perm-tag" :class="'perm-' + m.portal">{{
                  capitalize(m.portal)
                }}</span>
              </td>
              <td>{{ m.scope }}</td>
              <td>{{ m.active }}</td>
              <td>
                <button
                  class="btn btn-ghost btn-xs"
                  aria-label="Edit team member permissions"
                >
                  Edit
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script setup>
import { UserPlusIcon } from "vue-feather-icons";
import { TEAM_MEMBERS, ROLE_GUIDE, capitalize } from "./sms-config";

const team = TEAM_MEMBERS;
const roleGuide = ROLE_GUIDE;
</script>
